// BoardMain.js
import './menus/Buttons.css'; 
import React, { useEffect, } from 'react';

import useStore from '../store';
import Board from './board/Board';
import Spectator from './board/Spectator';
import { CanvasPuzzleBoard} from './canvaspuzzle/components/CanvasPuzzleBoard'; // <--- Import PuzzleBoard
// import PuzzleBoard from './puzzle/PuzzleBoard'; // <--- Import PuzzleBoard


// import SpectatorBoard from './SpectatorBoard';
import Spinner from './spinner/Spinner';

import GameNotLoaded from './menus/results/GameNotLoaded';
import ResultsOverlay from './menus/results/ResultsOverlay';

import ModeInfoOverlay from './menus/settings/ModeInfoOverlay';
import SettingsOverlay from './menus/settings/SettingsOverlay';
import DrawingSetsOverlay from './menus/settings/DrawingSetsOverlay';
import WordChangeOverlay from './menus/settings/WordChangeOverlay';

import EffectMenu from './menus/brush/EffectMenu';
import BrushMenu from './menus/brush/BrushMenu';
import EraserMenu from './menus/brush/EraserMenu';
import CustomizeBrush from './menus/brush/CustomizeBrush';

import LayerMenu from './menus/layer/LayerMenu';
import CustomizeLayer from './menus/layer/CustomizeLayer';
import PuzzleSettings from './canvaspuzzle/components/menu/PuzzleSettings';

import PremiumMenu from './menus/premium/PremiumMenu';

import PopupMessage from './menus/popup/PopupMessage';
import LogOverlay from './menus/LogOverlay';
import StrokeHistoryOverlay from './board/history/StrokeHistoryOverlay';


import RicRoll from './menus/rickroll/RicRoll';

import MafiaOverlay from './mafia/MafiaOverlay';
import ArcadeBoard from './arcade/ArcadeBoard.jsx';

function BoardMain() {

  const store = useStore.getState();

  useStore(state=>state.render);

  const spinner = useStore(state=>state.spinner);
  const isChecked = useStore(state=>state.isChecked);
  const isHacker = useStore(state=>state.isHacker);
  const gameInfo = useStore(state=>state.gameInfo);
  const gameError = useStore(state=>state.gameError);
  const canDraw = useStore(state=>state.canDraw);
  const strokesApplied = useStore(state=>state.strokesApplied);
  const canvasInitialized = useStore(state=>state.canvasInitialized);
  const boardReady = useStore(state=>state.boardReady);

  const showMenu = useStore(state=>state.showMenu);
  const showPremiumMenu = useStore(state=>state.showPremiumMenu);
  const showModeHelp = useStore(state=>state.showModeHelp);
  const popupMessage = useStore(state=>state.popupMessage);

  const menuId = showMenu?.[0];

  const puzzleState = useStore(state => state.ref.puzzle.state); // Изменено: получаем прямо из ref.puzzle.state
  const isPuzzleMode = !!gameInfo?.puzzle;
  const isMafiaMode = gameInfo?.mode === 'mafia';
  const isArcadeMode = gameInfo?.mode === 'arcade';

  if (isArcadeMode) {
    let a = 1;
  }
  
  // Чтобы отслеживать состояние через консоль
  useEffect(() => {
    if (isPuzzleMode) {
      console.log("Current puzzle state:", 
        puzzleState.isInitialized ? "initialized" : 
        puzzleState.isLoading ? "loading" : "not initialized");
    }
  }, [isPuzzleMode, puzzleState.isInitialized, puzzleState.isLoading]);

  useEffect(() => {
    if (canvasInitialized) {
      store.ref.drawing.methods.redraw?.().then(async ()=>{
        useStore.setState({ boardReady: true });
        const mafiaPublic = store.ref.info?.game?.mafiaPublic;
        if (mafiaPublic) {
          store.ref.mafia.methods.initMafia(mafiaPublic);
        }
      });
    }
  }, [canvasInitialized]);

  // Определяем готовность игры
  const isReady = isPuzzleMode ? puzzleState?.isInitialized : (boardReady || gameError);


  // Проверка наличия gameInfo для отладки
  if (gameInfo) {
    // gameInfo доступен
  }

  const showSpinner = ((!isReady && !isHacker) || spinner > Date.now());
  const showBoard = strokesApplied || gameError || isPuzzleMode;

  let showGameResults;
  if (!gameInfo?.puzzle && gameInfo?.results) {
    const resultsViewedAt = store.ref.work.methods.getUserGameSets()?.resultsViewedAt || 0;
    showGameResults = !resultsViewedAt;
    // showGameResults = Date.now() - resultsViewedAt > 1* 60 *1000;
  }

  const showProgress = !showBoard && !showGameResults;
  const hideSpectatorBoard = isMafiaMode && !canDraw;

  return (
    <>
      {/* {`useCDN: ${store.ref?.telegram?.useCDN} | socketCDN: ${process.env.REACT_APP_SOCKET_CDN_URL}`} */}
      {showSpinner && (
        <Spinner style = {{
          opacity: 1,
          transition: "opacity 0.5s ease", // Плавный переход за 0.5 секунды
        }} 
          showProgress={showProgress}
        />
      )}
      {isChecked && isHacker && (
        <RicRoll />
      )}

      {/* Новый оверлей Мафии */}
      {isMafiaMode && <MafiaOverlay />}

      {/* Режим аркады */}
      <div style={{
        opacity: isArcadeMode && !showSpinner ? 1 : 0,
        transition: "opacity 0.2s ease",
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        pointerEvents: isArcadeMode ? 'auto' : 'none'
      }}>
        {isArcadeMode && <ArcadeBoard />}
      </div>

      <div style={{
        zIndex: '1000',
        transition: "opacity 0.2s ease",
        }}>
        {
          menuId === 'strokeHistory' ? (
            <StrokeHistoryOverlay store={store} />
          ) : 
          menuId === 'settings' ? (
            <SettingsOverlay 
              store={store}
            />
          ) : 
          menuId === 'drawing' ? (
            <DrawingSetsOverlay 
              store={store}
            />
          ) : 
          menuId === 'brush' && canDraw ? (
            <BrushMenu 
              store={store}
            />
          ) : 
          menuId === 'eraser' && canDraw ? (
            <EraserMenu 
              store={store}
            />
          ) : 
          menuId === 'effect' && canDraw ? (
            <EffectMenu 
              store={store}

            />
          ) : 
          menuId === 'customizeBrush' && canDraw ? (
            <CustomizeBrush 
              store={store}
            />
          ) : 
          menuId === 'layer' && canDraw ? (
            <LayerMenu 
              store={store}
            />
          ) : 
          menuId === 'customizeLayer' && canDraw ? (
            <CustomizeLayer
              store={store}
            />
          ) : 
          menuId === 'word' ? (
            <WordChangeOverlay 
              store={store}
            />
          ) : 
          menuId === 'lag' ? (
            <LogOverlay 
              store={store}
            />
          ) : 
          menuId === 'puzzleSettings' ? (
            <PuzzleSettings 
              store={store}
            />
          ) : 
          null
        }

        {showPremiumMenu && (
          <PremiumMenu 
            store={store}
          />
        )}
        {gameInfo?.modeHelp && showModeHelp && !gameInfo?.results && (
          <ModeInfoOverlay 
            store={store}
          />
        )}
        {popupMessage && (
          <PopupMessage 
            store={store}
          />
        )}
        {showGameResults && (
          <ResultsOverlay 
            store={store}
          />
        )}
    
        {gameError && (
          <GameNotLoaded
            store={store}
            gameError={gameError}
          />
        )}
      </div>

      <div
        style={{
          opacity: (showBoard && !hideSpectatorBoard && !isArcadeMode) ? 1 : 0.00,
          transition: "opacity 0.3s ease",
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 10,
          pointerEvents: 'auto'
        }}
      >
        { 
          isPuzzleMode && <CanvasPuzzleBoard key="puzzleBoard" /> 
        }
        { 
          !isPuzzleMode && strokesApplied && (canDraw ? <Board /> : <Spectator />)
        }
      </div>
      
    </>
  );
}

export default BoardMain;